import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsQuestionModel } from "src/app/models/widgets/widgets-question.model";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { CloneService } from "../clone/clone.service";
import { WidgetsService } from "../widgets/widgets.service";
import { Logger } from "src/app/core/logger";
import { WidgetsMetadataService } from "../widgets/widgets-metadata.service";
import { QuestionService } from "../api/question.service";
import { CommandResequenceSectionsService } from "./command-resequence-sections.service";
import { CommandResequenceQuestionsService } from "./command-resequence-questions.service";
import { WidgetsSelectionService } from "../widgets/widgets-selection.service";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { Config } from "src/app/config";
import { WidgetsSectionModel } from "src/app/models/widgets/widgets-section.model";

@Injectable()
export class CommandQuestionService extends CommandAction {
  constructor(private widgetsCloneService: CloneService,
    private widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,
    private widgetsMetadataService: WidgetsMetadataService,
    private questionService: QuestionService,
    private commandResequenceSections: CommandResequenceSectionsService,
    private commandResequenceQuestions: CommandResequenceQuestionsService,
    private logger: Logger) {
    super();
  }

  public execute(parent: WidgetsAbstract, widget: WidgetsAbstract): WidgetsAbstract {
    let newSection: WidgetsSectionModel | undefined;
    const libraryQuestion: WidgetsQuestionModel = widget as WidgetsQuestionModel;
    const newQuestion: WidgetsQuestionModel = new WidgetsQuestionModel();

    // A Question is dragged & dropped directly to a form
    if (parent instanceof WidgetsFormModel && widget instanceof WidgetsQuestionModel) {
      if (Config.FEATURES.get('isQuestionToFormDropEnabled')) {
        // Create an empty section first
        newSection = new WidgetsSectionModel();
        newSection.parentId = parent.id;
      }
    } else {
      newQuestion.parentId = parent.id;
    }

    // If Question is not populated, call Question APIs using dbId attribute
    if (libraryQuestion.dbId) {
      // Asynchronous query: we need to previously populate newQuestion with as much info as possible
      newQuestion.dbId = libraryQuestion.dbId;
      newQuestion.typeId = libraryQuestion.typeId;    // Warning: it is in uppercase!
      newQuestion.name = libraryQuestion.name;
      newQuestion.description = libraryQuestion.description;
      this.questionService.getQuestion(libraryQuestion.dbId)?.subscribe(res => {
        /* eslint-disable @typescript-eslint/dot-notation  */
        const dbQuestion = JSON.parse(res["Template"]);
        newQuestion.TypeName = res["Type"].Description;
        /* eslint-enable */
        if (dbQuestion) {
          this.widgetsCloneService.cloneFromJS(dbQuestion, newQuestion, true, true, parent.id);

          // If a question has an original sequence number, it borns with it; otherwise use the next one available
          // if (!dbQuestion.seq) {
          // this.widgetsService.resequenceQuestions(this.widgetsService.getLayoutRoot()).then((seq) => {
          //   newQuestion.seq = ++seq;
          //   this.logger.log("resequenceQuestion " + newQuestion.seq);
          // });
          //}
          this.resequenceLayout();

          // A new Question borns selected
          this.selectionService.select(newQuestion).then(() => {
            this.widgetsService.setLayoutTouched();
          });
        }
      });
    } else {
      // Library Question is already populated. All information is available. Just clone.
      this.widgetsCloneService.cloneFromJS(libraryQuestion, newQuestion, true, true, parent.id);

      // If a question has an original sequence number, it borns with it
      // Otherwise use the next one available
      if (!libraryQuestion.seq) {
        this.widgetsService.resequenceQuestions(this.widgetsService.getLayoutRoot()).then((seq) => {
          newQuestion.seq = ++seq;
          this.logger.log("resequenceQuestion " + newQuestion.seq);
        });
      }

      // A new Question borns selected
      this.selectionService.select(newQuestion).then(() => {
        this.widgetsService.setLayoutTouched();
      });
    }

    // If a Question was dropped to the form, return the auto-created section instead...
    if (newSection) {
      newQuestion.parentId = newSection.id;
      newSection.children = [];
      newSection.children.push(newQuestion);
      // It is the section that will be inserted at the dropping position
      return newSection;
    }

    return newQuestion;
  }

  resequenceLayout() {
    this.commandResequenceSections.executeAsync(this.widgetsService.getLayoutRoot(), this.widgetsService.getLayoutRoot())
      .then((numSections) => {
        // this.logger.log("onResequence Resequenced " + numSections + " sections.");

        // Resequence Questions
        this.commandResequenceQuestions.executeAsync(this.widgetsService.getLayoutRoot(), undefined)
          .then((numQuestions) => {
            // this.logger.log("onResequence Resequenced " + numQuestions + " questions.");
          })
          .catch((error) => {
            this.logger.warn("onResequence Questions Error " + error);
          });
      })
      .catch((error) => {
        this.logger.warn("onResequence Sections Error " + error);
      });
  }
}
